import React, { memo, useCallback } from 'react';
import styled from 'styled-components';
import cx from 'classnames';
import SvgIcon from '~/src/root/components/SvgIcon';
import { ICONS_BY_SRC_NAME } from '~/assets/icons/icons';

const ItemButton = styled.button`
  min-width: 87px;
  height: 100%;
  outline: none;
  display: flex;
  align-items: center;
  margin-right: 8px;
  border-width: 2px;

  flex-basis: ${({ isThinButton }) => (isThinButton ? 'auto' : '100%')};
  flex-direction: ${({ isThinButton }) => (isThinButton ? 'row' : 'column')};
  justify-content: ${({ isThinButton }) => (isThinButton ? 'flex-start' : 'center')};
  border-bottom-style: ${({ isThinButton }) => (isThinButton ? 'none' : 'solid')};
  cursor: ${({ isActive }) => (isActive ? 'default' : 'pointer')};
`;

const ItemIconBox = styled.div`
  width: 24px;
  height: 24px;

  margin: 8px ${({ isThinButton }) => (isThinButton ? '8px' : '0')} 8px 0;
`;

const ItemTitle = styled.span`
  white-space: nowrap;
`;

const TopMenuItem = ({ id, title, path, onClick, isSingle = false, isVertical = false, getIsShownAsActive, className, tabIndex }) => {
  const isShownAsActive = isSingle || getIsShownAsActive?.(id);
  const isThinButton = isVertical || isSingle;

  const onButtonClick = useCallback(
    (e) => {
      onClick?.(e, id, path);
    },
    [id, path, onClick]
  );

  const svgClassNames = cx({
    'fill-inactive-tab-icon': !isShownAsActive,
    'fill-tab-icon': isShownAsActive,
  });

  const buttonClassNames = cx(className, {
    'bc-link c-tab-icon fill-tab-icon': isShownAsActive,
    'bc-window': !isShownAsActive,
    'c-inactive-tab-icon fill-inactive-tab-icon c-tab-icon-hover fill-tab-icon-hover': !isShownAsActive && !isThinButton,
    'b c-menu-icons': isThinButton,
  });

  return (
    <ItemButton
      className={buttonClassNames}
      onClick={onButtonClick}
      data-test={`${id}-btn`}
      isThinButton={isThinButton}
      isActive={isShownAsActive}
      tabIndex={tabIndex}
    >
      <ItemIconBox isThinButton={isThinButton}>
        <SvgIcon className={svgClassNames} path={ICONS_BY_SRC_NAME[id]} />
      </ItemIconBox>

      <ItemTitle>{title}</ItemTitle>
    </ItemButton>
  );
};

export default memo(TopMenuItem);
